import { useEffect, createContext, useState } from "react";

import { Dialog, DialogPanel } from "@headlessui/react";
import { observer } from "mobx-react-lite";

import { CommandMenu } from "@/components/command-menu/CommandMenu";
import { CommandMenuStore } from "@/components/command-menu/CommandMenuStore";
import { keyMatcher } from "@/utils/keyMatcher";

export const CommandMenuContext = createContext<CommandMenuStore>(new CommandMenuStore());

export const CommandMenuProvider = observer(function CommandMenuProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [store] = useState(new CommandMenuStore());

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (keyMatcher("Mod+KeyK", e)) {
        e.preventDefault();
        store.toggleDialog();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [store]);

  return (
    <CommandMenuContext.Provider value={store}>
      {children}
      <Dialog open={store.isOpen} onClose={() => store.closeDialog()} className="relative z-50">
        <div className="fixed inset-0 bg-black/5" aria-hidden="true" />
        <DialogPanel className="fixed top-1/4 flex w-screen justify-center">
          <CommandMenu store={store} />
        </DialogPanel>
      </Dialog>
    </CommandMenuContext.Provider>
  );
});
